export default {
  registration: {
    give_mandate: {
      badge_tooltip: "Management mandate granted",
    },
    invoice: {
      filter: {
        active: "Active filters",
        remove: "Remove filter {name}",
        status: "Filter by status",
      },
      title: ({ plural }) => plural(["Invoice", "Invoices"]),
      global_totals: ({ plural, named }) =>
        plural([
          `${named("count")} instalment in total on this flow (invoiced or not)`,
          `${named("count")} instalments in total on this flow (invoiced or not)`,
        ]),
      flow: {
        all: "All flows",
        opco: "OPCO",
        company: "Company",
      },
      emitted: {
        title: ({ plural }) => plural(["Issued invoice", "Issued invoices"]),
        resend: "Resend the invoice",
        resend_confirmation: "Are you sure you want to resend this invoice?",
        see_error: "View errors",
        error_date: "Error date: {date}",
        resend_rejection: {
          title: "The invoice could not be resent",
          reference: "Invoice",
          dismiss: "Close the resend error message",
        },
        see_details: "View details",
        download_pdf: "Download the invoice",
        download_completion_certificate: "Download the certificate of completion",
      },
      retry: {
        tooltip: "Retry PDF generation",
        success: "PDF generation has been successfully retried.",
      },
      credit_note: {
        document_title: "Credit note",
        download_pdf: "Download the credit note",
        emit: "Issue a credit note",
        title: "Issuing a credit note",
        confirm: "Are you sure you want to issue this credit note?",
        success: "Credit note issued successfully!",
        type_total: "Full credit note",
        type_partial: "Partial credit note",
        confirm_irreversible: "This action is final and cannot be undone.",
        pdf_failed: "The credit note was created but its PDF could not be generated.",
        pdf_failed_retry: "Do you want to retry the PDF generation now?",
        see_origin_invoice: "View original invoice",
        see_origin_invoice_label: "View original invoice No. {code}",
      },
      attached_credit_notes: {
        title: ({ plural, named }) =>
          plural([
            `This invoice has been subject to ${named("count")} credit note`,
            `This invoice has been subject to ${named("count")} credit notes`,
          ]),
        number: "Credit note No. {number}",
        issued_at: "Issued on {date}",
        reason: "Reason: {reason}",
        see_credit_note: "View credit note",
        see_credit_note_label: "View credit note No. {number}",
      },
      schedule: {
        title: ({ plural }) => plural(["Instalment to invoice", "Instalments to invoice"]),
        selected: ({ plural, named }) =>
          plural([`${named("count")} instalment selected`, `${named("count")} instalments selected`]),
        total_amount: "Total amount: {amount}",
        cancel_selection: "Cancel selection",
        emit: "Issue invoices",
        emit_confirmation: ({ plural, named }) =>
          plural([
            `Issue the invoice for the selected instalment?`,
            `Issue the invoices for the ${named("count")} selected instalments?`,
          ]),
        emit_progress: {
          title: "Issuing invoices",
          label: "Invoices issued: {done} / {total}",
        },
        rejection: {
          title: ({ plural, named }) =>
            plural([
              `${named("count")} instalment could not be queued for invoicing`,
              `${named("count")} instalments could not be queued for invoicing`,
            ]),
          reference: "Instalment",
          reason: "Reason",
          dismiss: "Close the rejected instalments message",
        },
      },
      emit: {
        title: "Issue invoices",
        cancel: "Cancel",
        confirm: "Issue invoices",
        summary: {
          line: "Your selection contains {schedules} for {recipients}, for a total of {amount}.",
          schedules: ({ plural, named }) => plural([`${named("count")} instalment`, `${named("count")} instalments`]),
          recipients: ({ plural, named }) => plural([`${named("count")} recipient`, `${named("count")} recipients`]),
        },
        alerts: {
          title: ({ plural }) => plural(["Alert to review", "Alerts to review"]),
          show: "Show alerts",
          hide: "Hide alerts",
          block_show: "Show the alerts of this recipient",
        },
        channel: {
          api_opco: "OPCO API",
          platform: "Platform submission",
          email: "Email delivery",
          unknown: "Unknown channel",
          region_label: "Instalments for the {channel} channel",
        },
        block_total: "Total incl. tax: {amount}",
        empty: "No instalment on this channel.",
      },
    },
    name: "Name",
    institution: "Institution",
    component: "Component",
    trainingCourse: "Promotion",
    group: "Group",
    Contact: "contact",
    registration_settings: "Registration settings",
    pedagogicInformations: "Educational information",
    fundingInformations: "Financial information",
    dates: "Dates",
    from_to: "from {from} to {to}",
    hourlyVolume: "Hourly volume",
    hourlyRemoteVolume: ({ named }) => `Of which ${named("volume")} h remotely`,
    hourlyCost: "Hourly cost of the service",
    prestationCost: "Service amount - Net of tax",
    amount: "Amount",
    modality: ({ plural }) => plural(["Modality", "Modalities"]),
    in_person: "In person",
    distanciel: "Remote",
    remoteVolume: "Including distance learning",
    degreePrepared: "Degree prepared",
    level: "Level",
    titleRncp: "RNCP title",
    degreeCode: "Degree code",
    calendar: "Calendar",
    program: "Program",
    apprenticeShipContract: "Apprenticeship contract",
    proContract: "Professionalization contract",
    rate: "Rate",
    publicAnnualRate: "Annual cost for public-sector employers",
    annualRate: "Annuel cost",
    totalRate: "Total cost",
    hourlyRate: "Hourly rate",
    followUp: "Follow-up",
    devices: "Devices",
    createdAt: "created at {date}",
    help: "Help",
    follow: "Follow",
    inProgress: "In progress",
    validatedAt: "Validated at {date} by {validator}",
    steps: "Steps",
    statistics: "Statistics",
    pending: "Pending",
    publicSector: "Public sector",
    privateSector: "Private sector",
    link_copied_success: "Link successfully copied to the clipboard!",
    head_office: "Head office",
    status: {
      upcoming: "Upcoming ",
      in_progress: "In progress",
      finalised: "Finalised",
      break_up: "Break-up",
      cancelled: "Cancelled",
    },
    insee_company: {
      title: ({ plural }) => plural(["INSEE company ", "INSEE companies"]),
      siret: "SIRET",
      activity: "Activity (NAF/APE)",
      details: "Details (name, sign, address)",
      creation: "Creation",
      state: "State",
      social_reason: "Social reason",
      current: "Current establishment",
      head_office: "Company headquarters",
      creation_date: "Creation date",
      work_force: "Workforce",
      status: "Status",
      principal_address: "Primary address",
      secondary_address: "Secondary address",
      empty_contact: "No contact details are provided for this company",
      undefined_work_force: "No data provided",
    },
    training_info: {
      search_by_branch: "Search by collective agreement",
      funding_coverage: "Funding coverage:",
      decree_cost: "Decree cost:",
      only_different_cost_displayed: "By default, only costs different from the decree cost are shown",
      info_tab: {
        general_info: "General information",
        rncp_sheet: "RNCP sheet",
        program: "Program",
        setttings: "Enrollment settings",
        matrix: "Matriz UE-Competencia",
        settings: "Enrollment settings",
        npec: "NPEC",
        contact: "contact for companies",
      },
      general_info: {
        institution_name: "Institution name",
        reference: "Reference",
        rncp_number: "RNCP number",
        offical_name: "Official name",
        diplome_type: "Diploma type",
        mention: "Name / mention",
        route: "Pathway",
        diplome_code: "Diploma code",
        status: "Status",
        logo: "Logo",
        partner_website_url: "Partner website URL",
        link: "Link",
        work_study_duration: "Work-study duration",
        total_cycle_time: "Total cycle duration",
        active: "Active",
        archived: "Archived",
      },
    },
    group_action: {
      see_sheet: "View the pre-registration form",
      see_contract: "View the contract",
      copy_sheet: "Copy the pre-registration form link",
      create: "Create a pre-registration form",
      cancel: {
        title: "Cancel this pre-registration form",
        confirmation: {
          title: "Are you sure you want to delete this record?",
          subtitle:
            'The entry will no longer be visible from the dashboard. You can restore it by selecting the "cancelled" files.',
          apprentice_subtitle: "The registration will no longer be visible from the dashboard.",
        },
        success: "Pre-registration form successfully deleted!",
        reset: {
          title: "Reactivate this pre-registration form",
          confirmation: {
            title: "Are you sure you want to reactivate this form?",
            subtitle: "The form will be reactivated and visible again to other users",
          },
          success: "Pre-registration form successfully reactivated!",
        },
      },
      download: {
        commitments: "Download the commitment certificate",
      },
    },
    dashboard: {
      go_to: "Access the dashboard for this training",
      go_to_institution: "Access the institution dashboard",
      see_group_detail: "View group details",
      contact_list: "Contact list",
      delete: {
        confirmation: "Are you sure you want to delete this group?",
        success: "Group successfully deleted!",
      },
    },
    creation: {
      alert: {
        title: "A registration already exists for this training",
        multipleTitle: "You already have registrations for this training",
      },
      info: "To create a new registration form, please first enter the candidate's information",
      success: ({ named }) =>
        `Pre-registration form of ${named("firstName")} ${named("lastName")} successfully created!`,
    },
    user_not_connected: "You must log in to access this area.",
    quote: {
      contract: "Contract",
      financial: "Funding",
      amount: "Amount grid",
      edit_cost: "Edit costs",
      subtitle: "Financial summary of the apprenticeship contract",
      initial_cost: "Initial cost",
      final_cost: "Final cost",
      modal_alert:
        "These changes will affect the amount billed to the company. Make sure the amounts comply with your agreement.",
      updated_cost: ({ plural, named }) => plural(["1 amount modified", `${named("number")} amounts modified`]),
      no_updated_cost: "No amount modified",
      edit: {
        date: {
          title: "Change the training dates (for this file)",
          success: "Training dates successfully changed!",
        },
        cost: {
          title: "Edit amounts",
          success: "Amounts successfully updated!",
          reset_cost: "Reset amounts",
          confirmation: "Are you sure you want to validate these amounts?",
          reset_confirmation: "Are you sure you want to reset these amounts?",
          reset_success: "Amounts successfully reset!",
          previous_amount: ({ named }) => `previously ${named("amount")}`,
          reference_legend: ({ named }) => `amounts from the agreement/quote sent on ${named("date")}`,
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Training cost",
          opcoo: "Support",
          mandatory_participation: "Mandatory contribution",
          mandatory_participation_tooltip:
            "Part of the funding imposed by the scheme or the funder.\n" +
            "It is added, where applicable, to the remaining cost.\n" +
            "In accordance with article L6332-14 of the French Labour Code, a contribution may be requested from the employer.",
          remaining_cost: "Remaining cost",
          remaining_cost_tooltip:
            "Amount not covered by the funder.\n" +
            "It is distinct from the mandatory contribution and depends on the coverage conditions validated by the OPCO.",
        },
      },
      duration: {
        title: "Duration",
      },
      startDate: {
        title: "Start date",
      },
      endDate: {
        title: "End date",
      },
      caption: {
        title: "* Amounts excluding VAT – VAT exemption",
        subtitle: "(art. 261, 4-4° du CGI, teaching activity).",
      },
      title: "Quote",
      verify: "Verify the quote",
      cost_historic: "Version history — Financial table",
      convention: {
        title: "Agreement",
      },
    },
    contact: {
      title: "A contact",
      success: "Contact added successfully!",
      info: "Enter the person to contact in the company. You can add multiple contacts in case of absence. The contact will receive the email upon validation of the step.",
      edit_succes: "Contact updated successfully!",
      edit: {
        success: "Contact updated successfully!",
        alert: "These changes apply to the user account across the entire platform.",
      },
      delete: {
        confirmation: "Are you sure you want to delete this contact?",
        success: "Contact successfully deleted!",
      },
      director: "Director / Signatory",
      temporary: "Temporary contact",
      interlocutor: "Administrative management contact",
      billing: "Billing contact",
      attendance: "Attendance contact",
      gestionnary: "Manager",
      different_name: "This name will appear on the agreement but does not create a user account.",
      mail_status: {
        waiting: "Awaiting activation",
        send: "Email sent",
        active: "Active",
      },
      account: {
        already_exist: {
          title: "This account already exists",
          subtitle:
            "The email address provided is already in use by an account (1 email = 1 user). The account holder can update their contact details in their personal space",
        },
      },
      registration: {
        title: "Registration contact",
        empty: "No registration contact provided",
      },
      company: {
        title: "Company contact (HR contact)",
        empty: "No company contact provided",
      },
    },
    reminder: {
      title: "Resend the company link notification",
      confirmation: {
        title: "Are you sure you want to resend the company link notification?",
      },
      send: "Send",
      success: "Notification sent successfully!",
    },
    comment: {
      title: "Comments",
      new: "New",
      unread: ({ plural }) => plural(["Unread message", "Unread messages"]),
      actions: ({ plural }) => plural(["Required action", "Required actions"]),
      add: "Add a comment",
      empty: "No comment provided",
      action_required: {
        done: "I have completed this action",
        doneBy: "Action completed by",
      },
      delete: {
        success: "Comment successfully deleted!",
        confirmation: "Are you sure you want to delete this comment?",
      },
    },
    contractType: {
      apprentice: "Apprentices",
      pro: "Professional contract",
    },
    document: {
      cerfa: {
        title: "CERFA",
        notice: "See the instructions",
      },
      convention: {
        title: "Convention",
      },
      update: {
        success: ({ named }) => `Your ${named("document")} has been successfully saved!`,
      },
      upload_at: `Uploaded on {date}`,
      version: "Version",
      status: {
        correction_requested: "Correction requested",
        verified: "Verified",
        sent: "Sent",
        deposited: "Deposited",
        to_send: "To send",
        to_be_modified: "Modification required",
        validated: "Validated",
        to_verify: "To verify",
      },
      actual_version: "Current version",
      delete: {
        confirmation: "Are you sure you want to delete this version?",
        success: "Version successfully deleted!",
      },
      validate: {
        confirmation: "Are you sure you want to validate this document?",
        success: "Document successfully validated!",
      },
      change: {
        title: "Correction request",
        success: "Complement request sent successfully!",
        cancel: {
          confirmation: "Are you sure you want to cancel this complement request?",
          success: "Complement request successfully cancelled!",
        },
      },
      verification: {
        title: "Verify documents",
        modal: "Verification",
        ask_modification: "Modification request",
        cancel_ask_modification: "Cancel the complement request",
        sign: "Approve the document",
      },
      empty: "No file found",
      error: "An error occurred while displaying the pdf",
      uploaded: "Uploaded file",
      generated: "Generated file",
      validation: {
        not_verify: "The CERFA and the convention must be verified to validate this step",
      },
    },
    step: {
      in_progress: "Step in progress",
      validation: {
        success: "Step successfully completed!",
      },
    },
    tab: {
      error: "Some fields in this tab have errors, please check them",
    },
    stamp: {
      action: "Stamp mode",
      stamped: { confirmed: "Document stamped successfully!" },
      cancel: "Exit stamp mode",
      tooltip: "Stamp the PDF,\nthe stamp will appear,\nat the center of the cursor\n(size: 90x40 mm)",
      remove: {
        title: "Remove the stamp",
        confirmation: "Are you sure you want to remove the stamp?",
        success: "Stamp removed successfully",
      },
    },
    save: {
      success: "Your registration form has been successfully submitted!",
    },
    request_changes: {
      title: "Request for additional information",
      confirmation: "Are you sure you want to send this request for additional information?",
      success: "Request for additional information sent successfully!",
      recipients: "The request for additional information will be sent to the following recipients:",
      requestAt: "Request for additional information submitted on {date} by {validator}",
      cancel: {
        confirmation: "Are you sure you want to cancel this request for additional information?",
        success: "Request for additional information cancelled successfully!",
      },
      new_submission: {
        confirmation: "Are you sure you want to submit a new version of the form?",
        success: "Form successfully resubmitted!",
      },
    },
    create: {
      confirmation: "Are you sure you want to create a new pre-registration file?",
      alert: {
        confirm: "Access your existing file",
        cancel: "Create a new file",
        multipleConfirm: "Access your files",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Alert ", "Alerts"]),
      level: {
        info: "Information",
        warning: "Warning",
        error: "Error",
      },
      active_unactive: "Active/Unactive",
      see_more: "See more",
      empty: "No alerts of level {level}",
    },
    contract: {
      title: "Contract",
      see_more: "See more",
      see_less: "See less",
      empty: "No contract available",
      see: "Access the contract",
      error: "Some information is incorrect, please correct it on the registration form",
      synchronize: {
        confirm: "Are you sure you want to synchronise this OPCO?",
        success: "Synchronisation completed successfully!",
      },
      opco: {
        edit: {
          success: "OPCO information updated successfully!",
        },
      },
      billing: {
        title: "Contract financial summary",
      },
    },
    empty_registation_list: "No pre-registration form available",
    company_dashboard: {
      following_contract: {
        title: "List of contracts",
      },
    },
    contract_status: {
      init: "Initialised",
      to_send_to_training_center: "To be sent",
      sent_to_training_center: "Sent",
      validated_training_center: "Validated",
      signed: "Signed",
      error: "Error",
      archived: "Archived",
    },
    years: "years",
    workInProgress: "Work in progress",
    valid: "Validate",
    uaiCode: "UAI code",
    tutor: "Tutor",
    ufa: "UFA",
    cfa: "CFA",
    training: "Training",
    totalWorkForce: "Total workforce",
    socialReason: "Company name",
    signIn: "Create account",
    settings: "Settings",
    see_more: "See more",
    pricePolicyInfo3: "The rate is aligned with coverage.",
    pricePolicyInfo2: "Remaining charge only if coverage is below rate; if higher, rate applied based on coverage.",
    pricePolicyInfo1: "Remaining charge only if coverage is less; coverage capped at rate, even if higher.",
    previousSituation: "Previous situation",
    prev: "Previous",
    preContractSituation: "Pre-contract situation",
    phone: "Phone",
    opco: "OPCO",
    opcoComparison: {
      title: "Data comparison",
      caption: "OPCO and Studea data comparison",
      baseline: "OPCO data and Studea data",
      empty: "No data to compare",
      label: "Label",
      seeDifferences: "View differences",
      level: {
        minor: "Minor difference",
        strict: "Major difference",
      },
    },
    salaryDetail: {
      empty: "No salary data",
    },
    noNeedAccount: "I already have an account",
    next: "Next",
    needAccount: "I don't have an account",
    nationality: "Nationality",
    map: "Apprenticeship supervisor",
    male: "Mr.",
    loginInfo2: "Sign in to access the registration form",
    loginInfo: "Sign in or create an account to access the registration form",
    login: "Sign in",
    lastInstitution: "Last institution",
    lastDegreePrepared: "Last degree prepared",
    lastDegreeObtained: "Last degree obtained",
    ineCode: "INE code",
    idcc: "IDCC",
    iAm: "I am",
    hourlyTrainingVolume: "Number of hours",
    hostCompanyContact: "Host company contact",
    hostCompany: "Host company",
    generalInformations: "General information",
    function: "Function",
    firstName: "First name",
    female: "Ms.",
    employerType: "Employer type",
    employerSubType: "Employer subtype",
    email: "Email",
    download_training_sheet: "Download training sheet",
    ypareo: {
      title: "Ypareo",
      sync_button: "Synchronise with Ypareo",
      sync_success: "File synchronised with Ypareo",
      sync_error: "Ypareo synchronisation failed",
      running: "Synchronisation in progress…",
      error_indicator: "Synchronisation error",
      synced_at: "Synchronised on {date} (Ypareo ID {id})",
      resend_button: "Resend",
      log_title: "Ypareo synchronisation log",
      log_date: "Date",
      log_created: "Created",
      log_updated: "Updated",
      log_excluded: "Skipped",
      log_errors: "Errors",
      log_empty: "No log available for this file.",
      error_tooltip: "Ypareo synchronisation error: {ypareo_sync_error}",
    },
    department: "Department",
    degree: "Degree",
    createCompanyAccount: "Create company account",
    createApprenticeAccount: "Create apprentice account",
    contacts: "Contacts",
    company: "Company",
    civility: "Civility",
    birthDate: "Date of birth",
    apprenticeMaster2: "Apprentice supervisor 2",
    apprenticeMaster: "Apprentice supervisor",
    anApprentice: "An apprentice",
    age: "Age",
    administratorCompanyContact: "Company headquarters contact",
    administratorCompany: "Company headquarters",
    address: "Address",
    siret: "SIRET",
    activityCode: "Activity code (NAF)",
    accountExistSubTitle: "with the provided email address. Please sign in instead.",
    accountExist: "An account already exists",
    aCompany: "A company",
    endDate: "End date",
    startDate: "Start date",
    opco_submission: {
      title: "Submit to OPCO",
      convention: "Agreement",
      folder: "File",
      confirmation: {
        title: "Confirm submission to OPCO",
        subtitle: {
          title: "By submitting the file to the OPCO, the CFA:",
          li_1: "Attests to the accuracy of the information mentioned in this request",
          li_2: "Attests that the information entered in the form is consistent with the information in the contract concluded with the apprentice",
          li_3: "Attests that the CERFA has been approved by the responsible training organization",
          li_4: "Attests that the CERFA has been signed by all parties (employer, apprentice and their legal representative if applicable)",
          li_5: "Undertakes to keep supporting documents available for inspection by the relevant authorities (OPCO, administration)",
        },
        confirm: "Confirm submission",
      },
      json: {
        title: "JSON sent to OPCO",
        see: "View sent JSON",
        received: {
          title: "JSON received from OPCO",
          see: "View JSON",
        },
      },
      success: {
        title: "File successfully transmitted",
      },
      error: {
        title: "Transmission failed",
      },
      response: {
        title: "OPCO response",
        message: "Response message",
      },
      status: {
        success: "Success",
        in_progress: "In progress...",
        failed: "Failed",
        waiting: "Waiting to be sent",
      },
      message: {
        processing: "Sending in progress",
      },
      manual: {
        alert:
          "The employer is responsible for concluding and submitting the work-study contract (apprenticeship or professionalization) to their Skills Operator (OPCO), or to the DREETS for public employers, as soon as it is signed, and no later than within the 5 business days following the start of the contract. This submission is crucial to trigger financial aid and ensure social security coverage.",
        success: "OPCO submission completed successfully!",
      },
    },
    opco_folder: {
      send: {
        done: "OPCO submission complete",
      },
      last_sync: "Last sync: {date}",
    },
    first_connexion: "First login",
    actor: {
      cfa: "CFA",
      ufa: "UFA",
      company: "Company",
    },
    legal_responsible: {
      required: "You must add at least one legal guardian (Maximum 2)",
      add: "Add a legal guardian",
      add_second: "Add a second legal guardian",
      edit: "Edit a legal guardian",
      success_add: "Legal guardian added successfully!",
      success_edit: "Legal guardian updated successfully!",
      delete: {
        success: "Legal guardian removed successfully!",
        confirmation: "Are you sure you want to delete this legal guardian?",
      },
    },
    correction_requested: {
      title: "Modification requests",
      historic: "Modification request history",
      creation: "Correction requested by {creator} on {date}",
    },
    params: {
      give_mandat: "Management mandate configuration",
    },
    updated_cost: ({ plural, named }) => plural(["1 amount modified", `${named("number")} amounts modified`]),
    no_updated_cost: "No amount modified",
    amendment: "Amendment",
    mission: "Missions",
    salary: "Remuneration",
    financing_amount: "Financial Summary — Quote",
    invoice_tab: {
      title: "Funding/Invoicing",
    },
    due_date: {
      valid: "Accept OPCO due dates",
      edit: "Edit the breakdown",
    },
    schedule: {
      title: "Payment schedule",
      company: "Company",
      mode: {
        title: "Mode",
        description:
          "Forecast = initial schedule before the APEC is received, OPCO = received through the Convergence API, Manual = edited by the CFA",
        unavailable: "This mode is not available for this contract",
      },
      forecast: "Forecast",
      manual: "Manual",
      empty: "No payment schedule yet",
      error: "An error occurred while loading the payment schedule",
      column_installment: "Instalment",
      column_type: "Type",
      column_start_date: "Start",
      column_end_date: "End",
      column_amount: "Amount",
      type: {
        initial: "Initial",
        intermediate: "Intermediate",
        balance: "Balance",
      },
      manual_edit: {
        edit_button: "Edit the manual breakdown",
        title: "Manual instalment breakdown",
        locked: "Locked instalment",
        locked_amount: "Amount of instalment {installment} (locked): {amount}",
        locked_start_date: "Start date of instalment {installment} (locked): {date}",
        locked_end_date: "End date of instalment {installment} (locked): {date}",
        amount_label: "Amount of instalment {installment}",
        start_date_label: "Start date of instalment {installment}",
        end_date_label: "End date of instalment {installment}",
        add_line: "Add an instalment",
        delete_line: "Delete instalment {installment}",
        delete_confirmation:
          "Delete this instalment? Its amount will be transferred to the closest unlocked instalment.",
        reset: "Reset",
        reset_confirmation:
          "Reset the manual schedule? All unlocked instalments will be replaced by the automatic calculation.",
        save: "Save",
        balance_target: "Net engaged amount",
        balance_current: "Total allocated",
        balance_gap: "Gap",
        balance_ok: "The schedule is balanced.",
        balance_error: "The sum of amounts must equal the net engaged amount before saving.",
        saved: "Manual breakdown saved",
        error: "An error occurred while updating the manual breakdown",
      },
    },
    export: {
      workflow: "Export registrations (flow)",
      contract_data: "Contract export",
      missions: "Export missions",
      financial: "Financial export",
    },
  },
};
